import { useEffect } from "react";
import { Link, useLocation } from "wouter";
import { motion } from "framer-motion";
import { ArrowRight, Globe, Languages, MessageCircle, Shield, Sparkles, Users, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/use-auth";
import { SEOHead } from "@/components/seo-head";
import chatBg from '../assets/images/line-graphic.png';
import Header from '@/components/LandingPage/Header'
import HeroSection from '@/components/LandingPage/HeroSection'
import Translation from '@/components/LandingPage/Translation'
import Travel from '@/components/LandingPage/Travel';
import ChattingSection from '@/components/LandingPage/ChattingSection';
import CTASection from '@/components/LandingPage/CTASection';

import Footer from '@/components/LandingPage/Footer';



export default function LandingPage() {
  console.log("LANDING PAGE FROM CLIENT FOLDER");
  const [, setLocation] = useLocation();
  const { user, isInitialized, migrationCompleted } = useAuth();

  useEffect(() => {
    if (user && isInitialized && migrationCompleted) {
      const savedLanguage = localStorage.getItem('vyzle-chat-language');
      const hasCompletedOnboarding = localStorage.getItem('vyzle-chat-onboarded');
      if (!savedLanguage || !hasCompletedOnboarding) {
        setLocation("/");
      } else {
        setLocation("/app");
      }
    }
  }, [user, isInitialized, migrationCompleted, setLocation]);

  return (
    <div className="w-full bg-[#fff]">
     <div className="max-w-[1920px] mx-auto">
      
      <Header />
      <HeroSection />
      <Translation />
      <Travel />
  <div
  className="relative bg-cover bg-no-repeat bg-center"
  style={{ backgroundImage: `url(${chatBg})` }}
>
  {/* light opacity layer */}
  <div className="absolute inset-0 bg-white/80"></div>

  {/* content stays normal */}
  <div className="relative z-10">
    <ChattingSection />
    <CTASection />
  </div>
</div>
      <Footer />
    </div> 
    </div>
  );
}


